import { createAction, props } from '@ngrx/store';
import {Config} from "../../types";
import {CONFIG_LOAD, CONFIG_SET_LOADING_ERROR, CONFIG_SET} from "./action-types";

export const loadConfig = createAction(CONFIG_LOAD);
export const setConfig = createAction(CONFIG_SET, props<{ config: Config }>());
export const setLoadingError = createAction(CONFIG_SET_LOADING_ERROR);
